import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, batch } from 'react-redux';
import { createSelector } from 'reselect';
import Loading from 'react-loading-bar';
import { create } from 'jss';
import rtl from 'jss-rtl';
import { StylesProvider, jssPreset } from '@material-ui/styles';
import { withTheme, withStyles, createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import 'react-loading-bar/dist/index.css';

import { basename } from 'aurora-utils/history';
import { changeDirectionAction } from 'aurora-composition/actions/auroraUiActions';
import changeLocale from '../LanguageProvider/actions';
import applicationTheme from '../../styles/applicationTheme';

const styles = {
  root: {
    width: '100%',
    minHeight: '100%',
    marginTop: 0,
    zIndex: 1,
  },
};
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

function AuroraCoreLayoutWrapper(props) {
  const { classes, children } = props;
  const [pageLoaded, setPageLoaded] = useState(true);
  const { direction } = useSelector(
    createSelector(
      reduxState => reduxState.ui,
      ui => {
        return {
          direction: ui.direction,
        };
      },
    ),
  );
  const dispatch = useDispatch();

  const theme = useMemo(() => createTheme(applicationTheme(direction)), [direction]);

  const onProgressShow = () => {
    setPageLoaded(true);
  };

  const onProgressHide = () => {
    setPageLoaded(false);
  };

  const playProgress = () => {
    onProgressShow();
    setTimeout(() => {
      onProgressHide();
    }, 500);
  };

  useEffect(() => {
    playProgress();

    return () => {
      onProgressShow();
    };
  }, []);

  useEffect(() => {
    let lang = 'en';
    if (basename === '/ar') lang = 'ar';
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    batch(() => {
      dispatch(changeDirectionAction(dir));
      dispatch(changeLocale(lang));
    });
    document.dir = dir;
  }, []);

  return (
    <StylesProvider jss={jss}>
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <div className={classes.pageLoader}>
            <Loading show={pageLoaded} color={theme.palette.primary.main} showSpinner={false} />
          </div>
          {children}
        </div>
      </MuiThemeProvider>
    </StylesProvider>
  );
}

AuroraCoreLayoutWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default withTheme(withStyles(styles)(AuroraCoreLayoutWrapper));
